import englishMessages from 'ra-language-english';
export default {
  ...englishMessages,
  simple: {
    action: {
      resetViews: 'Reset views'
    }
  }
};
